import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useEffect } from "react";
import HouseCard from "./HouseCard";
import useInView from "./utils/useInView";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { useGetHouses, useHouses } from "./stores/otherStore";

const CardSlider = () => {
    const [ref, inView] = useInView();
    const houses = useHouses();
    const getHouses = useGetHouses();

    useEffect(() => {
        void getHouses();
    }, [getHouses]);

    return (
        <div
            ref={ref}
            className={`opacity-0 scale-90 transition-all duration-500 
        ${inView ? "animate-fadeIn" : ""}`}
        >
            <div className="container">
                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    spaceBetween={100}
                    slidesPerView={3}
                    navigation={{ enabled: true }}
                    breakpoints={{
                        0: {
                            slidesPerView: 1,
                            spaceBetween: 0,
                            navigation: { enabled: false },
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 50,
                            navigation: { enabled: true },
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 100,
                            navigation: { enabled: true },
                        },
                    }}
                    pagination={{ clickable: true }}
                    autoplay={{ delay: 5000 }}
                    loop={true}
                    className="lg:w-[1400px] lg:py-10 md:px-20 px-10 py-8"
                >
                    {houses.map((house) => (
                        <SwiperSlide key={house.id}>
                            <HouseCard house={house} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default CardSlider;
